import App from './App.svelte';

const app = new App({
	target: document.getElementById('fortune-wheel-app-container'),
	props: {
		allPrizes: window.allPrizes === undefined ? {} : window.allPrizes,
		availablePrizes: window.availablePrizes === undefined ? {} : window.availablePrizes,
		showBuyMoreSpinsBtn: window.showBuyMoreSpinsBtn === undefined ? false : window.showBuyMoreSpinsBtn,
		buyMoreSpinsUrl: window.buyMoreSpinsUrl === undefined ? null : window.buyMoreSpinsUrl,
		availableSpins: window.availableSpins === undefined ? null : window.availableSpins,
		collectedCodes: window.collectedCodes === undefined ? [] : window.collectedCodes,
	}
});

export default app;